<ng-container *ngIf="iframeUrl$ | async as iframeUrl">
    <div class="flip-book-iframe-container">
        <iframe title="Car Parts Promotion" allow="clipboard-write"
            sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
            allowfullscreen="true"
            class="flip-book-iframe"
            [src]="getSanitizedIframeUrl(iframeUrl)"></iframe>
    </div>
</ng-container>